import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getCodBill = params => {
  return axios.request({
    url: "/finance/cod/branch/checkBill/yt",
    method: "get",
    params
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/${data.id}`,
    method: "put",
    data
  });
};

export const writeOff = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/writeOff/${id}`,
    method: "post",
    data
  });
};

export const batchWriteOff = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/batchWriteOff`,
    method: "post",
    data
  });
};

export const getListDetails = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/${id}`,
    method: "get"
  });
};

export const codConfirmBill = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/confirmed`,
    method: "post",
    data
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/cod/branch/checkBill/yt",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const getCountryCurrency = params => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/totalCountryAndRate/${params.id}`,
    method: "get",
		params
  });
};

export const codReStatistics = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/reStatistics/${data.id}`,
    method: "post",
    data
  });
};

export const getDetails = (id, params) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/details/${id}`,
    method: "get",
    params
  });
};

export const del = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/removeDetail/${id}`,
    method: "delete",
    data
  });
};

export const exportBill = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/billDetailDaoChu/${id}`,
    method: "post"
  });
};

export const importBill = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/billDetailDaoRu/${id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const delCod = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/${id}`,
    method: "delete"
  });
};
export const addCnbNo = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/appendClientCheckBill/${data.id}`,
    method: "post",
    data
  });
};

export const deleteShipment = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/moveOutBill/${data.id}`,
    method: "delete",
    data
  });
};

export const exportBillDetails = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/returnExport/${id}`,
    method: "get"
  });
};

export const cancelAgentOff = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/cancelAgentOff/${id}`,
    method: "post"
  });
};

export const cancelClientOff = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/cancelClientOff/${id}`,
    method: "post"
  });
};

export const checkClientAlipay = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/checkClientAlipay`,
    method: "post",
    data
  });
};

export const getExtFile = id => {
  return axios.request({
    url: `/finance/cod/branch/extFile/read/${id}`,
    method: "get"
  });
};

export const uploadExtFile = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/extFile/upload/${id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const delExtFile = (bill_id, id) => {
  return axios.request({
    url: `/finance/cod/branch/extFile/del/${bill_id}/${id}`,
    method: "delete"
  });
};

export const saveExtFile = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/extFile/save/${id}`,
    method: "post",
    data
  });
};

export const getAnalyze = params => {
  return axios.request({
    url: `/finance/bill_analyze/cod/analyze/${params.id}`,
    method: "get",
    params
  });
};

export const getBatchRate = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/batchTotalCountryAndRate`,
    method: "post",
    data
  });
};

export const saveBatchRate = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/batchReStatistics`,
    method: "post",
    data
  });
};

export const cancelConfirm = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/cancelConfirm`,
    method: "post",
    data
  });
};

export const waitOffBill = params => {
  return axios.request({
    url: `/finance/hedge/waitOffBill`,
    method: "get",
    params
  });
};

export const codDoHedge = data => {
  return axios.request({
    url: `/finance/hedge/codDoHedge`,
    method: "post",
    data
  });
};

export const changeBillHeader = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/changeBillHeader`,
    method: "post",
    data
  });
};

export const batchExportBillFiles = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/yt/batchExportBillFiles`,
    method: "post",
    data
  });
};

export const setRate = data => {
  return axios.request({
    url: `/finance/hedge/setRate`,
    method: "post",
    data
  });
};
